import styled from 'styled-components'

export const Container = styled.div`
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-color: var(--the-white);
  background-image: url("${props => props.src}");
  background-size: ${({ contain }) => contain ? 'contain' : 'cover'};
  width: 40px;
  height: 40px;
  background-repeat: no-repeat;
  background-position: center center;
  ${({ customSize }) => customSize && `width="${customSize}px; height="${customSize}px;`}
`
